import gql from 'graphql-tag';

export const ALLVISITAS = gql`
    query todasVisitas($idUser:Int!){
        visitasUsuario(idUser:$idUser){
            _id
            tienda{
                idDB
                nombre
            }
            estado
            fechaCreacion
          plantilla{
            nombre
          }
        }
    }
`;

export const VISITA = gql`
    query{
        preguntas{
            _id
            subcategoria
            {
                _id
                nombre
            }
            enunciado
            peso
            orden
        }
    }
`;

export const CREARVISITA = gql`
    mutation($plantilla:String, $tiendas:[String], $idUser:Int!, $periodoVisitas:String){
        newVisitas(plantilla:$plantilla, tiendas:$tiendas, idUser:$idUser, periodoVisitas:$periodoVisitas)
    }
`;

export const INFOCREARVISITAS = gql`
    query($idUser:Int!){
        tiendas: tiendas(idUser:$idUser){
            id
            idDB
            nombre
            categoria
            locacion
            negocio
            activo
        }

        plantillas: plantillas{
            _id
            nombre
            descripcion
            activo
        }
    }
`;
